import _ from 'lodash'
import React from 'react'
import { Route } from 'react-router-dom'
import { ConnectedSwitch } from 'reactRouterConnected'
import Loadable from 'react-loadable'
import Page from 'components/CustomComponents/Layout/Page'
import NotFoundPage from 'pages/NotFoundPage'
import { localizeRoute } from 'l8n'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => null,
  })

const routes = [
  {
    path: '/autoreg',
    component: loadable(() => import('pages/RegistrationPage')),
  },
  {
    path: '/settings',
    component: loadable(() => import('pages/SettingsPage')),
  },
  {
    path: '/details',
    component: loadable(() => import('pages/DetailsPage')),
  },
  {
    path: '/withdrawals',
    component: loadable(() => import('pages/WithdrawalsPage')),
  },
  {
    path: '/payments',
    component: loadable(() => import('pages/PaymentsPage')),
  },
  {
    path: '/customers',
    component: loadable(() => import('pages/CustomersPage')),
  },
  {
    path: '/integration',
    component: loadable(() => import('pages/IntegrationPage'))
  },
  {
    path: '/password-recovery',
    component: loadable(() => import('pages/PasswordRecoveryPage')),
  },
  {
    path: '/login',
    component: loadable(() => import('pages/LoginPage')),
  },
  {
    path: '/',
    component: loadable(() => import('pages/DashboardPage')),
  }
]

class Routes extends React.Component {
  timeoutId = null

  componentDidMount() {
    this.timeoutId = setTimeout(
      () => routes.forEach((data, index) => routes[index].component.preload()),
      5000,
    )
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  render() {
    return (
      <ConnectedSwitch>
        {_.cloneDeep(routes).map((route) => {
          return <Route
              key={localizeRoute(route)}
              path={localizeRoute(route)}
              exact={true}
              component={route.component}
          />
        })}
        
        {_.cloneDeep(routes).map((route) => {
          return <Route
              key={route.path}
              path={route.path}
              exact={true}
              component={route.component}
          />
        })}
        
        <Route
          render={() => (
            <Page>
              <NotFoundPage />
            </Page>
          )}
        />
      </ConnectedSwitch>
    )
  }
}
export { routes }
export default Routes



// WEBPACK FOOTER //
// ./src/routes.js